const initialState = () => ({
  internalAdmins: [],
  userAgencyRoles: null,
  userRoles: [],
})

const getters = {
  INTERNAL_ADMINS: state => state.internalAdmins,
  USER_AGENCY_ROLES: state => state.userAgencyRoles,
  USER_ROLES: state => state.userRoles,
}

const actions = {}

const mutations = {
  RESET_STATE (state, payload) {
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_INTERNAL_ADMINS (state, payload) {
    state.internalAdmins = payload
  },
  ADD_INTERNAL_ADMIN (state, payload) {
    state.internalAdmins.push(payload)
  },
  UPDATE_INTERNAL_ADMIN (state, payload) {
    const index = state.internalAdmins.map(o => o.id).indexOf(payload.id)
    if (index > -1) {
      state.internalAdmins.splice(index, 1, payload)
    }
  },
  SET_USER_AGENCY_ROLES (state, payload) {
    state.userAgencyRoles = payload
  },
  SET_USER_ROLES (state, payload) {
    state.userRoles = payload
  },
}

export default {
  namespaced: true,
  state: initialState(),
  getters,
  actions,
  mutations,
}
